import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <g transform="translate(-46 -563)">
        <rect
          width={29}
          height={29}
          fill={props.fillSecondary}
          rx={10}
          transform="translate(46 563)"
        />
        <path
          fill={props.fillPrimary}
          d="M60.923 567.965l2.677 5.432a.472.472 0 00.355.258l5.995.871a.472.472 0 01.261.8l-4.338 4.228a.472.472 0 00-.136.418l1.024 5.971a.472.472 0 01-.685.5l-5.362-2.819a.472.472 0 00-.439 0l-5.362 2.819a.472.472 0 01-.685-.5l1.024-5.971a.472.472 0 00-.136-.418l-4.331-4.223a.472.472 0 01.261-.8l5.995-.871a.472.472 0 00.355-.258l2.681-5.432a.472.472 0 01.846-.005z"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
